import React, { useState } from 'react';
import styles from '../../styles/home.module.css';

const FAQSection = ({
  title,
  subtitle,
  description,
  faqs = [],
  groups,
  extra,
  itemColumns = 1,
}) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const sourceGroups = groups?.length ? groups : [{ title: null, faqs }];
  let nextIndex = 0;
  const indexedGroups = sourceGroups.map((group) => ({
    title: group.title,
    faqs: group.faqs.map((faq) => ({
      ...faq,
      index: nextIndex++,
    })),
  }));

  const useTwoColumns = itemColumns === 2;

  return (
    <section className={styles.faqSection}>
      <div
        className={`${styles.faqGrid} ${useTwoColumns ? styles.faqGridStacked : ""}`}
        style={
          useTwoColumns
            ? undefined
            : {
                maxWidth: "1200px",
                margin: "0 auto",
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "30px",
                alignItems: "flex-start",
              }
        }
      >
        <div className={styles.faqLeft}>
          <h5
            style={{
              color: "darkgreen",
              fontWeight: "bold",
              marginBottom: "10px",
              fontSize: "1.7em",
            }}
          >
            {title}
          </h5>
          {subtitle ? (
            <h2
              style={{
                fontSize: "1.8em",
                fontWeight: "700",
                lineHeight: "1.4",
                marginBottom: "15px",
              }}
            >
              {subtitle}
            </h2>
          ) : null}
          <p
            className={styles.paragraph}
            style={{
              color: "#555",
              lineHeight: "1.6",
              fontSize: "1.1em",
            }}
          >
            {description}
          </p>
          {extra}
        </div>
        <div
          className={`${styles.faqRight} ${useTwoColumns ? styles.faqRightTwoCol : ""}`}
        >
          {indexedGroups.map((group, groupIndex) => (
            <div
              key={group.title || `group-${groupIndex}`}
              className={useTwoColumns ? styles.faqItemsTwoCol : undefined}
            >
              {group.title ? (
                <h3
                  className={`${styles.faqGroupTitle} ${useTwoColumns ? styles.faqGroupTitleSpan : ""}`}
                  style={groupIndex === 0 ? { marginTop: 0 } : undefined}
                >
                  {group.title}
                </h3>
              ) : null}
              {group.faqs.map((faq) => (
            <div
              key={faq.index}
              style={{
                backgroundColor: "#fff",
                borderRadius: "8px",
                marginBottom: useTwoColumns ? 0 : "10px",
                border: "1px solid #ddd",
              }}
            >
              <div
                className={`faq-question ${
                  activeIndex === faq.index ? "active" : ""
                }`}
                onClick={() => toggleFAQ(faq.index)}
                style={{
                  padding: "15px",
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  fontWeight: "bold",
                  borderBottom:
                    activeIndex === faq.index ? "1px solid #ddd" : "none",
                }}
              >
                <span>{faq.question}</span>
                {activeIndex === faq.index ? (
                  <svg
                    width="24"
                    height="26"
                    viewBox="0 0 24 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M17.7961 18.8843C18.1369 19.1998 18.6631 19.1998 19.0039 18.8843L19.2956 18.6143C19.6755 18.2624 19.6755 17.6616 19.2956 17.3098L12.6039 11.1139C12.2631 10.7983 11.7369 10.7983 11.3961 11.1139L4.70441 17.3099C4.32445 17.6617 4.32445 18.2625 4.70442 18.6144L4.99607 18.8844C5.33686 19.1999 5.86312 19.1999 6.2039 18.8844L12 13.5177L17.7961 18.8843Z"
                      fill="#656B61"
                    />
                  </svg>
                ) : (
                  <svg
                    width="24"
                    height="26"
                    viewBox="0 0 24 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M6.2039 7.1157C5.86312 6.80015 5.33686 6.80015 4.99607 7.1157L4.70442 7.38565C4.32445 7.73753 4.32445 8.33834 4.70441 8.69021L11.3961 14.8861C11.7369 15.2017 12.2631 15.2017 12.6039 14.8861L19.2956 8.69015C19.6755 8.33827 19.6755 7.73746 19.2956 7.38558L19.0039 7.11563C18.6631 6.80008 18.1369 6.80008 17.7961 7.11563L12 12.4823L6.2039 7.1157Z"
                      fill="#656B61"
                    />
                  </svg>
                )}
              </div>
              {activeIndex === faq.index && (
                <div
                  className="faq-answer"
                  style={{
                    padding: "15px",
                    color: "#555",
                    lineHeight: "1.6",
                  }}
                >
                  {faq.answer}
                </div>
              )}
            </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;